export const createMarkup = (html = '') => {
  return { __html: html };
};
